import React, { useState } from 'react';
import SplitHeading from '../../components/ui/SplitHeading';
import Button from '../../components/ui/Button';
import BookCallModal from '../../components/BookCallModal';

// The close: one line, two actions.
export default function FinalCTA() {
  const [booking, setBooking] = useState(false);
  return (
    <section className="border-t border-line py-16 md:py-24">
      <div className="container-x">
        <SplitHeading as="h2" lines={["Let's build it."]} className="display-xl" onEnter />
        <div className="mt-10 flex flex-wrap gap-3">
          <Button to="/contact" size="lg">Start a project</Button>
          <Button variant="ghost" size="lg" onClick={() => setBooking(true)}>Book a free call</Button>
        </div>
        <p className="mt-8 max-w-md text-sm text-mist">Reply within one business day. Kareem answers every project brief personally.</p>
      </div>
      <BookCallModal open={booking} onClose={() => setBooking(false)} />
    </section>
  );
}
